import { memo, type ReactElement } from 'react'

function TransactionsIcon (): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 448 512">
      <path
        d="M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 360l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zM441 145c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l342.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"
        className="fill-current text-wpy-gray"
      />
    </svg>
  )
}

export default memo(TransactionsIcon)
